import { useEffect, useState } from "react";
import { LoadingManager, LoadingState } from "./index";

export const useIsPageLoaded = () => {
  const [isPageLoaded, setIsPageLoaded] = useState(
    LoadingManager.loadingState === "loaded"
  );

  useEffect(() => {
    const updateLoadedState = (state: LoadingState) => {
      if (state === "loaded") {
        setIsPageLoaded(true);
      }
    };

    return LoadingManager.subscribeToMainPageResourcesLoaded(updateLoadedState);
  }, []);

  return { isPageLoaded };
};
